import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { PaymentAPI } from '../../api/PaymentAPI'
import { SubscriptionAPI } from '../../api/SubscriptionAPI'
import confetti from 'canvas-confetti'
import Loader from '../../component/Loader'
import { CiCircleCheck } from 'react-icons/ci'
import { isCoach, userRoles } from '../../util/UserRoles'

const SubscriptionPlatform = () => {
    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState("");
    const [subscriptionId, setSubscriptionId] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const hasFetchedRef = useRef(false);
    const navigate = useNavigate();
    const { userInfo, clubId } = useSelector((state) => state.user);
    const { state } = useLocation();
    let priceId = state.priceId;
    let quantity = state.quantity;
    let planId = state.planId;
    let planFor = state.planFor;
    const fireworksAnimation = () => {
        var duration = 4 * 1000;
        var animationEnd = Date.now() + duration;
        var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

        function randomInRange(min, max) {
            return Math.random() * (max - min) + min;
        }

        var interval = setInterval(function () {
            var timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            var particleCount = 50 * (timeLeft / duration);
            // since particles fall down, start a bit higher than random
            confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
            confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
        }, 250);
    }
    useEffect(() => {
        if (!hasFetchedRef.current) {
            hasFetchedRef.current = true;
            if (userInfo.userId) {
                fireworksAnimation();
                setTimeout(() => {
                    navigate('/account-setup', {
                        replace: true,
                        state: {
                            reload: true,
                            updateFirstStep: true
                        }
                    })
                }, 4000);
            }
        }
    }, [userInfo?.userId]);

    const createPaymentClientSecret = async () => {
        try {
            setIsLoading(true);
            const publishKey = await PaymentAPI.getPublishKey();
            setStripePromise(loadStripe(publishKey.Data));
        } catch (error) {
            console.error('error', error)
            setIsLoading(false);
        }
    }
    if (isLoading) {
        return <Loader />
    }
    return <div className='subscription_free_payment_container'>
        <div className='free_trial_purchase_body'>
            <CiCircleCheck className='free_trial_purchase_icon' />
            <h1>Thank you</h1>
            <p>Your 30-day free trial plan is now active.</p>
        </div>
    </div>;


    // const appearance = {
    //     theme: 'flat',
    //     rules: {
    //         '.Input': {
    //             border: '1px solid rgba(156, 150, 150, 0.358)',
    //             boxShadow: 'none',
    //         },
    //         '.Input:focus': {
    //             border: '1px solid #8fbd04',
    //             boxShadow: 'none',
    //         },
    //         '.Input--invalid': {
    //             borderColor: '#df1b41',
    //         },
    //         '.Tab': {
    //             padding: '10px 15px',
    //             boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.52)'
    //         },
    //         '.Tab--selected': {
    //             backgroundColor: '#8fbd04',
    //             boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.52)'
    //         },
    //         '.Tab--selected:focus': {
    //             "outline": '2px solid #8fbd04',
    //             "boxShadow": 'none'
    //         },
    //         '.TabLabel': {
    //             color: '#30313d',
    //         },
    //         '.Label': {
    //             fontWeight: '500',
    //         },
    //     },
    // };

    // const options = {
    //     clientSecret,
    //     appearance,
    // };
    // return (
    //     <div className='subscription_payment_container'>
    //         {isLoading && <Loader />}
    //         <h1>Purchase your plan</h1>
    //         {clientSecret && stripePromise && (
    //             <Elements stripe={stripePromise} options={options}>
    //                 <SubscriptionFormPlatform />
    //             </Elements>
    //         )}
    //     </div>
    // )
}

export default SubscriptionPlatform